/** Midnight UTC on the same calendar day as `date`. */
export function startOfUtcDay(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}
//# sourceMappingURL=day-math.js.map